export default __webpack_public_path__ + "static/media/ico_wear_disabled.a8dbc808.svg";